import * as actions from "../constants/ActionTypes";

const initialState = {
    exposed: false,
    selected: 0
};

export default function viewerReducer(state = initialState, action = {}) {
    let {type, index, on, res, args} = action;
    let selected, exposed;

    switch (type) {
        case actions.SELECT_CHART:
            selected = state.selected;
            if (index == state.selected) {
                return state;
            }

            res = {selected: index};
            return {...state, ...res};

        case actions.TOGGLE_EXPOSE:
            if (!!on == state.exposed) {
                return state;
            }

            res = {exposed: !!on};
            return {...state, ...res};

        case actions.LOAD_STATE:
            ({exposed, selected} = {...initialState, ...args});

            if (exposed === state.exposed && selected == state.selected) {
                return state;
            }
            return {exposed, selected};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/kpi/store/reducers/viewer.js